import React from 'react';
import { Button } from './Button';
import { trackAddToCart } from '../lib/metaPixel';
export function Offer() {
  const handlePurchaseClick = () => {
    trackAddToCart({
      content_name: 'The 4-Hour Reset Bundle',
      content_ids: ['4-hour-reset'],
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
  };
  return <section id="offer" className="bg-charcoal text-white py-24 px-6" data-id="element-65">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-66">
        <div className="order-2 md:order-1" data-id="element-67">
          <img src="https://cdn.magicpatterns.com/uploads/pfCbAMiF6KZ33LsK62Hkxa/1.png" alt="The 4-Hour Reset Bundle" className="rounded-2xl shadow-2xl w-full object-cover border border-white/10" data-id="element-68" />
        </div>

        <div className="order-1 md:order-2 space-y-8" data-id="element-69">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif leading-tight" data-id="element-70">
            Get the complete 4-Hour Reset Bundle today.
          </h2>
          <p className="text-lg font-sans text-white/80 leading-relaxed" data-id="element-71">
            Stop the 2 AM guessing game and get the exact 15-minute blueprint to
            reclaim your sleep and your sanity.
          </p>

          <div className="bg-white/5 p-6 rounded-xl border border-white/10 inline-block" data-id="element-72">
            <p className="font-sans text-white/60 uppercase tracking-wider text-sm mb-3" data-id="element-73">
              Digital Access
            </p>
            <div className="flex items-center gap-4 flex-wrap" data-id="element-74">
              <p className="text-5xl font-serif font-bold" data-id="element-75">$6.39</p>
              <div className="flex flex-col" data-id="element-76">
                <span className="text-xl font-sans text-white/40 line-through leading-none" data-id="element-77">
                  $19.97
                </span>
                <span className="mt-1 inline-block bg-sage text-charcoal text-xs font-sans font-bold uppercase tracking-wider px-2 py-1 rounded-full" data-id="element-78">
                  68% OFF
                </span>
              </div>
            </div>
          </div>

          <div data-id="element-79">
            <a href="https://momurgreat.com/cart/46029377208481:1" target="_blank" rel="noopener noreferrer" className="inline-block" onClick={handlePurchaseClick} data-id="element-80">
              <Button className="w-full md:w-auto text-lg bg-sage hover:bg-sage-light text-charcoal" data-id="element-81">
                GET THE 4-HOUR RESET NOW
              </Button>
            </a>
            <p className="mt-4 text-sm text-white/50 font-sans text-center md:text-left" data-id="element-82">
              Immediate digital delivery. Access your sleep blueprint in the
              next 60 seconds.
            </p>
          </div>
        </div>
      </div>
    </section>;
}